import React from "react";
import { Box, Flex, Text } from "rebass/styled-components";
import styled from "styled-components";

import { IUserProfile } from "MVVM/@types";
import { ProfileButtons } from "../../Views/Profile/Components/Header/Components/ProfileButtons";
import { useProfileCardViewModel } from "./ViewModel";
import { Banner } from "./Components/Banner";
import { ProfileCardHeader } from "./Components/Header";
import { Content } from "./Components/Content";
import { MatchHistoryButtons } from "./Components/MatchHistoryButtons";

interface IProfileCardProps {
  userId?: string;
  username?: string;
  avatar?: string;
  className?: string;
  isMatchHistory?: boolean;
  gameId?: string;
  displayName?: string;
  matchId?: string;
}

export const ProfileCard = ({
  userId,
  username,
  avatar,
  className,
  isMatchHistory = false,
  gameId,
  displayName,
  matchId,
}: IProfileCardProps) => {
  const {
    user: profileUser,
    loading,
    error,
  } = useProfileCardViewModel({
    username,
  });

  if (!userId && !username && !isMatchHistory) return null;

  if (error) {
    return (
      <CardContainer className={className}>
        <ErrorContainer>
          <Text color="shade300">Failed to load profile</Text>
        </ErrorContainer>
      </CardContainer>
    );
  }

  const handleCardClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <CardContainer className={className} onClick={handleCardClick}>
      <Banner coverImageUrl={profileUser?.coverImageUrl} />

      <ProfileCardHeader
        profileUser={profileUser || undefined}
        username={username || displayName}
        avatar={avatar}
        userGroup={profileUser?.userGroup?.type}
        rank={profileUser?.rank}
        loading={loading}
      />

      {!loading && (
        <ButtonSection>
          {profileUser ? (
            <ProfileButtons
              user={profileUser as IUserProfile}
              variant="profileCard"
            />
          ) : isMatchHistory ? (
            <MatchHistoryButtons gameId={gameId} matchId={matchId} />
          ) : null}
        </ButtonSection>
      )}

      {profileUser && <Content profileUser={profileUser} loading={loading} />}
    </CardContainer>
  );
};

const CardContainer = styled(Box)`
  background: ${({ theme }) => theme.colors.navy300};
  border: 1px solid ${({ theme }) => theme.colors.chalkAlpha20};
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  min-height: 250px;
  position: relative;
  width: 352px;
`;

const ButtonSection = styled(Box)`
  padding-left: 20px;
`;

const ErrorContainer = styled(Flex)`
  align-items: center;
  flex-direction: column;
  height: 200px;
  justify-content: center;
`;
